/**
 * Layout for when the hub runs as a micro-frontend inside the shell.
 *
 * It used to be a 129-line copy of AppLayout that differed only in how it
 * offset the app rail — and that difference is now moot: AppShell's sidebar is
 * in normal flow, so it inherits the `body` margin the rail sets and neither
 * layout offsets anything by hand. What is left that's genuinely embedded-only
 * is registering the shell's apps, so that's all this does before handing off.
 */

import { useEffect } from 'react';
import { usePlatformStore } from '@/stores/platform.store';
import { useAuthStore } from '@/stores/auth.store';
import { AppLayout } from './AppLayout';

export function EmbeddedLayout() {
  const { setAvailableApps } = usePlatformStore();
  const { user } = useAuthStore();

  // Apps come from the ID token's apps claim, stored on the user by auth-callback.
  useEffect(() => {
    const userApps = (user as any)?.apps;
    if (userApps && userApps.length > 0) {
      setAvailableApps(
        userApps.map((app: any) => ({
          id: app.client_id,
          name: app.name,
          slug: app.client_id,
          icon: app.icon || 'Box',
          color: '#3B82F6',
          isCore: false,
          sortOrder: 0,
        })),
      );
    }
  }, [user, setAvailableApps]);

  return <AppLayout />;
}
